import { a3Copy } from "@/components/assignments/a3-copy";
import type { BriefMaterial } from "@/lib/api/assignments";

/**
 * Who decides access to an attached material (PRD §2-§3, ADR 0040). IMAM
 * holds a reference only: Drive or the link's host answers every open.
 */
export const MATERIAL_ACCESS: Record<BriefMaterial["source"], string> = {
  drive: "Google decides who can open this file.",
  link: a3Copy.theLinkSHostDecidesWhoCanOpenIt,
};

export type ShownMaterial = Pick<BriefMaterial, "position" | "title" | "file_url" | "source">;
